import { connect } from 'react-redux';
import CTViewer from './CTViewer.js';
import OHIF from 'ohif-core';

const { setTimepoints, setMeasurements } = OHIF.redux.actions;
const { setViewportSpecificData } = OHIF.redux.actions;

const mapStateToProps = state => {
  return {
    viewports: state.viewports.viewportSpecificData,
    activeViewportIndex: state.viewports.activeViewportIndex,
    user: state.api.user.ctInfo,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onTimepointsUpdated: timepoints => dispatch(setTimepoints(timepoints)),
    onMeasurementsUpdated: measurements =>
      dispatch(setMeasurements(measurements)),
    setViewportSpecificData: (viewportIndex, data) =>
      dispatch(setViewportSpecificData(viewportIndex, data)),
  };
};

const ConnectedCTViewer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CTViewer);

export default ConnectedCTViewer;
